// src/import/ui/contants/authKeys.js
export const TOKEN_KEY = 'auth_token';
export const USER_KEY  = 'userId';
export const LOGIN_KEY = 'is_login';